import chamadoService from '@/services/chamado'

const state = {
  categorias: [],
  categoriasOwners: {
    categorias: [],
    userOwnerCategorias: [],
  },
  loadingCategorias: false,
  loadingCategoriasOwners: false,
  categoriasLoaded: false,
  categoriasOwnersLoaded: false,
}

const getters = {
  categorias: state => state.categorias,
  categoriasOwners: state => state.categoriasOwners,
  isOwnerOfAnyCategory: state => state.categoriasOwners.userOwnerCategorias.length > 0,
  loadingCategorias: state => state.loadingCategorias,
  loadingCategoriasOwners: state => state.loadingCategoriasOwners,
  categoriasLoaded: state => state.categoriasLoaded,
  categoriasOwnersLoaded: state => state.categoriasOwnersLoaded,

  isOwnerCategoria: (state, getters, rootState, rootGetters) => (categoriaId) => {
    const userId = rootGetters['autenticacao/id_usuario']

    if (!categoriaId || !userId) return false

    return state.categoriasOwners.categorias
      ?.find(c => c.id === categoriaId)
      ?.owners?.some(o => o.id === userId) ?? false
  },

  isSuperAdmin: (state) => {
    const { categorias = [], userOwnerCategorias = [] } = state.categoriasOwners
    return categorias.length === userOwnerCategorias.length
  },
}

const mutations = {
  SET_CATEGORIAS(state, categorias) {
    state.categorias = categorias
    state.categoriasLoaded = true
  },
  SET_CATEGORIAS_OWNERS(state, data) {
    state.categoriasOwners = data
    state.categoriasOwnersLoaded = true
  },
  SET_LOADING_CATEGORIAS(state, loading) {
    state.loadingCategorias = loading
  },
  SET_LOADING_CATEGORIAS_OWNERS(state, loading) {
    state.loadingCategoriasOwners = loading
  },
  RESET_CATEGORIAS(state) {
    state.categorias = []
    state.categoriasLoaded = false
  },
  RESET_CATEGORIAS_OWNERS(state) {
    state.categoriasOwners = {
      categorias: [],
      userOwnerCategorias: [],
    }
    state.categoriasOwnersLoaded = false
  },
  RESET_ALL(state) {
    state.categorias = []
    state.categoriasOwners = {
      categorias: [],
      userOwnerCategorias: [],
    }
    state.loadingCategorias = false
    state.loadingCategoriasOwners = false
    state.categoriasLoaded = false
    state.categoriasOwnersLoaded = false
  },
}

const actions = {
  async fetchCategorias({ commit, state }) {
    // Se já carregou, não carrega novamente
    if (state.categoriasLoaded && state.categorias.length > 0) {
      return state.categorias
    }

    commit('SET_LOADING_CATEGORIAS', true)
    try {
      const { data } = await chamadoService.listarCategorias()
      commit('SET_CATEGORIAS', data)
      return data
    } catch (error) {
      console.error('Erro ao carregar categorias:', error)
      throw error
    } finally {
      commit('SET_LOADING_CATEGORIAS', false)
    }
  },

  async fetchCategoriasOwners({ commit, state }) {
    // Se já carregou, não carrega novamente
    if (state.categoriasOwnersLoaded && state.categoriasOwners.categorias.length > 0) {
      return state.categoriasOwners
    }

    commit('SET_LOADING_CATEGORIAS_OWNERS', true)
    try {
      const { data } = await chamadoService.getCategoriasOwners()
      commit('SET_CATEGORIAS_OWNERS', data)
      return data
    } catch (error) {
      console.error('Erro ao carregar categorias owners:', error)
      throw error
    } finally {
      commit('SET_LOADING_CATEGORIAS_OWNERS', false)
    }
  },

  // Força recarga (útil após criar/editar categoria)
  async reloadCategorias({ commit }) {
    commit('RESET_CATEGORIAS')
    commit('SET_LOADING_CATEGORIAS', true)
    try {
      const { data } = await chamadoService.listarCategorias()
      commit('SET_CATEGORIAS', data)
      return data
    } catch (error) {
      console.error('Erro ao recarregar categorias:', error)
      throw error
    } finally {
      commit('SET_LOADING_CATEGORIAS', false)
    }
  },

  async reloadCategoriasOwners({ commit }) {
    commit('RESET_CATEGORIAS_OWNERS')
    commit('SET_LOADING_CATEGORIAS_OWNERS', true)
    try {
      const { data } = await chamadoService.getCategoriasOwners()
      commit('SET_CATEGORIAS_OWNERS', data)
      return data
    } catch (error) {
      console.error('Erro ao recarregar categorias owners:', error)
      throw error
    } finally {
      commit('SET_LOADING_CATEGORIAS_OWNERS', false)
    }
  },

  clearCache({ commit }) {
    commit('RESET_ALL')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
